/*
 * header-modal.js  — aria-hidden 制御（フォーカス修正）
 * @package krobot
 */
'use strict';

/* --- 共通変数 --- */
const isiOS = /iphone|ipad|ipod|macintosh/.test( navigator.userAgent.toLowerCase() ) && 'ontouchend' in document;
let modalScrollY = 0;

/* --- フォーカストラップ --- */
function trapFocus( modal, nextTrigger ) {
	const focusables = [ ...modal.querySelectorAll( 'a,button,input,[tabindex]' ) ] // ← -1 を除外しない
		.filter( ( el ) => el.offsetParent !== null );
	if ( ! focusables.length ) {
		return;
	}

	const first = focusables[ 0 ];
	const last = focusables[ focusables.length - 1 ];

	function onKey( e ) {
		if ( e.key !== 'Tab' ) {
			return;
		}
		if ( e.shiftKey ) {
			if ( first.ownerDocument.activeElement === first ) {
				e.preventDefault(); last.focus();
			}
		} else if ( last.ownerDocument.activeElement === last ) {
			e.preventDefault();
			const closeBtn = modal.querySelector( '.modal_header .close button' );
			( closeBtn || nextTrigger || first ).focus();
		}
	}
	modal.addEventListener( 'keydown', onKey );
	modal.addEventListener( 'modalClosed', () => modal.removeEventListener( 'keydown', onKey ), { once: true } );
}

/* --- DOM 完了後 --- */
document.addEventListener( 'DOMContentLoaded', () => {
	/* 開閉トグル */
	function toggle( e ) {
		if ( e.type === 'keydown' && ! [ 'Enter', ' ', 'Spacebar' ].includes( e.key ) ) {
			return;
		}
		e.preventDefault();

		const trig = e.currentTarget;
		const modalId = trig.getAttribute( 'aria-controls' );
		const modal = document.getElementById( modalId );
		if ( ! modal ) {
			return;
		}

		const isOpen = modal.getAttribute( 'aria-hidden' ) === 'false';

		if ( ! isOpen ) {
			/* === OPEN === */
			trig.setAttribute( 'aria-expanded', 'true' );
			modal.removeAttribute( 'hidden' );
			modal.setAttribute( 'aria-hidden', 'false' );

			// 初期フォーカス（タイミングをずらす）
			const first = modal.querySelector( '.modal-container a, .modal-container input' );
			if ( first ) {
				setTimeout( () => first.focus(), 50 );
			}

			const nextTrig = [ ...document.querySelectorAll( '.js-modal-trigger' ) ]
				.find( ( el ) => el.getAttribute( 'aria-expanded' ) !== 'true' && el.getAttribute( 'aria-controls' ) !== modalId );
			trapFocus( modal, nextTrig );

			modalScrollY = window.pageYOffset;
			if ( isiOS ) {
				document.body.style.position = 'fixed';
				document.body.style.top = -modalScrollY + 'px';
			}
			document.body.classList.remove( 'on' );
			document.body.classList.add( 'off' );
		} else {
			/* === CLOSE === */
			trig.setAttribute( 'aria-expanded', 'false' );

			modal.style.opacity = '0';
			setTimeout( () => {
				modal.setAttribute( 'aria-hidden', 'true' );
				modal.style.opacity = '';
				modal.dispatchEvent( new Event( 'modalClosed' ) );
			}, 300 );

			trig.focus();

			if ( isiOS ) {
				document.body.style.position = '';
				document.body.style.top = '';
				window.scrollTo( 0, modalScrollY );
			}
			document.body.classList.remove( 'off' );
			document.body.classList.add( 'on' );
		}
	}

	/* すべての .js-modal-trigger へバインド */
	document.querySelectorAll( '.js-modal-trigger' ).forEach( ( el ) => {
		el.addEventListener( 'click', toggle );
		el.addEventListener( 'keydown', toggle );
	} );

	/* Esc で閉じる */
	document.addEventListener( 'keydown', ( e ) => {
		if ( ! [ 'Escape', 'Esc' ].includes( e.key ) ) {
			return;
		}
		const openBtn = document.querySelector( '.js-modal-trigger[aria-expanded="true"]' );
		if ( openBtn ) {
			openBtn.click();
		}
	} );

	/* .close ボタン → 次トリガーへフォーカス */
	const nextMap = {
		'modal-search-menu': 'modal-search-menu',
		'modal-region-menu': 'modal-region-menu',
		'modal-hamburger-menu': 'modal-hamburger-menu',
	};

	function closeFocus( e ) {
		const isKey = e.type === 'keydown';
		if ( isKey && ! [ 'Enter', ' ', 'Spacebar' ].includes( e.key ) ) {
			return;
		}

		const btn = e.target.closest( '.modal_header .close button' );
		if ( ! btn ) {
			return;
		}

		/* 閉じる */
		btn.click();

		/* 次トリガーへフォーカス */
		const modal = btn.closest( '[id^="modal-"]' );
		const nextId = nextMap[ modal.id ];
		const nextTrigger = document.querySelector( `.js-modal-trigger[aria-controls="${ nextId }"]` );
		if ( nextTrigger ) {
			setTimeout( () => nextTrigger.focus(), 0 );
		}
	}
	document.addEventListener( 'click', closeFocus );
	document.addEventListener( 'keydown', closeFocus );
} );
